import checkCDV from '../utils/check-cdv';

export default function (app) {
	app.directive('cdv', function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: (scope, elm, attrs, ctrl) => {
				var validate = (viewValue) => {
					if (viewValue) {
						var normalizedBankAccount = viewValue.replace(/[^0-9]*/g, '');
						if (normalizedBankAccount.length == 16 || normalizedBankAccount.length == 24) {
							ctrl.$setValidity('financialAccountCDV', checkCDV(normalizedBankAccount));
						}
					}
					return viewValue;
				};
				ctrl.$parsers.unshift(validate);
				ctrl.$formatters.unshift(validate);
			}
		};
	});
};
